import type { SearchQuery } from 'src/types/__generated__/graphql';
import type { ExtendedAdsQueryVariables } from '../types/extendedAdsQueryVariables';
import { defaultQueryVariables } from 'src/constants/ad';

export const getAdsVariablesFromSavedSearch = (
    search: SearchQuery['search'],
): ExtendedAdsQueryVariables | undefined => {
    const parameters = search?.parameters;
    if (parameters && search.placeGeometry) {
        const { place } = JSON.parse(parameters) as ExtendedAdsQueryVariables;
        return {
            ...(JSON.parse(parameters) as ExtendedAdsQueryVariables),
            orderBy: defaultQueryVariables.orderBy,
            offset: defaultQueryVariables.offset,
            limit: defaultQueryVariables.limit,
            place: place
                ? {
                      googlePlaceId: place.googlePlaceId,
                      description: place.description,
                      cityName: place.cityName,
                  }
                : undefined,
            places: [
                {
                    type: search.placeGeometry.type,
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    coordinates: search.placeGeometry.coordinates,
                },
            ],
            placesSource: search.placeGeometry.source,
        };
    }

    return undefined;
};
